import styled from 'styled-components';

export const TextBody = styled.p`
  font-size: 0.875rem;
  a,
  a span,
  a:hover,
  a:hover span {
    text-decoration-color: transparent;
    color: #007db8;
    cursor: pointer;
  }
  td {
    vertical-align: middle;
  }
`;

export const HeaderImage = styled.img`
  max-width: 100%;
`;
